import { useRealPathName } from 'lib/hooks/sitecore/useRealPathName';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

export function useRouterUtils() {
  const router = useRouter();
  const pathname = useRealPathName();
  const isReady = router.isReady;
  const removeQueryParameter = useCallback(
    (paramName: string) => {
      if (!isReady) {
        throw new Error('Router is not ready, check if ready before calling.');
      }
      const { [paramName]: _paramName, path: _path, ...restQuery } = router.query;
      const hashFragment = router.asPath.split('#')[1];
      const hash = hashFragment ? `#${hashFragment.replace(/^#+/, '')}` : undefined;

      router.replace(
        {
          pathname: pathname,
          query: restQuery,
          ...(hash ? { hash } : {}),
        },
        undefined,
        { shallow: true }
      );
    },
    [router, pathname, isReady]
  );
  const getQueryParameter = useCallback(
    (paramName: string) => {
      if (!isReady) {
        return undefined;
      }
      return router.query[paramName];
    },
    [router, isReady]
  );
  return {
    removeQueryParameter,
    getQueryParameter,
    isReady,
  };
}
